// extracted by mini-css-extract-plugin
export var button = "_9q-0";
export var icon = "_9q-1";